var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.528399 9.34638C0.528399 9.34638 7.20315 8.95385 11.0925 16.3579C11.0925 16.3579 12.3188 22.3809 11.792 23.9697C11.792 23.9697 5.30902 24.7153 1.74199 18.8315C1.74199 18.8315 -1.16136 13.766 0.528399 9.34638Z",
    fill: "#3698F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7907 0C11.7907 0 21.8408 5.93779 16.3691 19.0138C16.3691 19.0138 14.3443 22.8228 11.7907 23.9277C11.7907 23.9277 4.07726 19.3212 5.99456 8.26805C5.98613 8.26805 7.17655 2.17034 11.7907 0Z",
    fill: "#3698F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73649 10.6958C5.73649 10.6958 13.7428 14.7582 11.7918 23.9463C11.7918 23.9463 4.43863 19.7697 5.73649 10.6958Z",
    fill: "#2776D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf2);
export default __webpack_public_path__ + "static/media/leaf2.97b1dbda6032390178cd07d79af3ec9a.svg";
export { ForwardRef as ReactComponent };